import openedStickerBackgroundImg from './opened_sticker_background.png';
import './OpenedStickerBackground.css';

/** Opened sticker pack background — 210.999 437.7363 659×519. */
export function OpenedStickerBackground() {
  return (
    <img
      className="sticker-reward-opened-bg"
      src={openedStickerBackgroundImg}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
